import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';

export default class SystemHaltNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Halt';
        this.id = 'node_system_halt';
        this.linkedFeature = 'general';

        this.inputs = [
            {
                name: 'Halt',
                portId: 'sys.halt',
                params: [],
            },
        ];
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;

        const links = project.getNodeLinks(this, 'sys.halt');
        if (links.length > 0) {
            const link = links[0];
            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                template: 'sys.halt()',
            });
        }

        return blocks;
    }

    getDetails(): string {
        return `
##### Halt
This block causes the device to halt (pause).

In _debug_ mode: The device will enter the PAUSE state. You can resume code execution by pressing the **Run** button.

In _release_ mode: The device will halt. You must restart the device to resume code execution.`;
    }
}
